<template>
	<FormulateForm v-if="!loading" v-model="form" ref="form" @submit="save" style="max-width:100%">
		<div class="fieldgroup">
			<div class="lbl required">
				<div class="label">Nombre del tipo de entrada</div>
			</div>
			<div class="data">
				<FormulateInput name="name" validation-name="Nombre del grupo" validation="required" />
			</div>
		</div>

		<div class="fieldgroup">
			<div class="lbl required">
				<div class="label">Validez de la entrada</div>
			</div>
			<div class="data">
				<FormulateInput
					type="date"
					label="Fecha y hora límite de ingreso"
					name="validAt"
					:displayFormat="'DD-MM-YYYY HH:mm'"
					validation-name="Fecha límite de acceso al evento"
					:validation="`before:${$moment(this.limitDateAt).format('YYYY-MM-DD HH:mm:01')}`"
					class="flex-grow-1 "
					:max="$moment(this.limitDateAt).format('YYYY-MM-DD HH:mm:01')"
					:help="
						`El evento inicia el ${$moment(event.startAt).format('dddd DD MMM YYYY, HH:mm')} y termina el
					${$moment(event.endAt).format('dddd DD MMM YYYY, HH:mm')}`
					"
					:validation-messages="{
						before: `La fecha límite de venta no puede ser posterior a ${$moment(this.limitDateAt).format(
							'DD-MM-YYYY HH:mm'
						)}`
					}"
				/>
			</div>
		</div>

		<hr />

		<div class="fieldgroup">
			<div class="lbl required">
				<div class="label">Opciones de venta</div>
			</div>
			<div class="data">
				<FormulateInput
					class="mb-3"
					v-model="validAtEnd"
					type="checkbox"
					label="Disponible hasta el final del evento"
					@input="validAtCheck"
				/>

				<div class="mb-3" v-show="!validAtEnd">
					<FormulateInput
						type="date"
						label="Disponible hasta"
						name="sellAt"
						:displayFormat="'DD-MM-YYYY HH:mm'"
						validation-name="Fecha límite de venta"
						:validation="`before:${$moment(this.limitDateAt).format('YYYY-MM-DD HH:mm:01')}`"
						class="flex-grow-1"
						:max="$moment(this.limitDateAt).format('YYYY-MM-DD HH:mm:01')"
						:validation-messages="{
							before: `La fecha límite de venta no puede ser posterior a ${$moment(
								this.limitDateAt
							).format('DD-MM-YYYY HH:mm')}`
						}"
					/>
				</div>

				<div class="row row-xs">
					<div class="col-4">
						<FormulateInput
							type="number"
							label="Mínimo por pedido"
							name="minPerOrder"
							validation-name="Cantidad mínima"
							validation="required|min:1"
							:min="1"
						/>
					</div>
					<div class="col-4">
						<FormulateInput
							type="number"
							label="Máximo por pedido"
							name="maxPerOrder"
							validation-name="Cantidad máxima"
							:validation="`required|number|min:${form.minPerOrder}`"
							:min="form.minPerOrder"
						/>
					</div>
				</div>
			</div>
		</div>

		<hr />

		<div class="fieldgroup">
			<div class="lbl required">
				<div class="label">Cupo</div>
			</div>
			<div class="data">
				<FormulateInput
					type="number"
					label="Total de entradas disponibles"
					name="ticketsLimit"
					validation-name="Cantidad de tickets"
					validation="required"
				/>
			</div>
		</div>

		<hr />

		<div class="fieldgroup">
			<div class="lbl required">
				<div class="label">Datos personales</div>
			</div>
			<div class="data">
				<div class="box-selectors ">
					<div
						class="box-selector"
						:class="{ selected: !form.holderRequired }"
						@click="form.holderRequired = false"
					>
						<div class="title">Tickets al portador</div>
						<p>
							Los tickets serán al portador y no se le solicitará comprobar la identidad al ingresar al
							evento
						</p>
					</div>
					<div
						class="box-selector"
						:class="{ selected: form.holderRequired }"
						@click="form.holderRequired = true"
					>
						<div class="title">Tickets personales</div>
						<p>
							Cada ticket deberá contar con la información personal del portador y se comprobará su
							identidad al ingreso del evento.
						</p>
					</div>
				</div>
			</div>
		</div>

		<hr />

		<div class="fieldgroup">
			<div class="lbl required">
				<div class="label">Tickets</div>
			</div>
			<div class="data">
				<FormulateInput type="group" name="ticketTypes" repeatable add-label="Agregar ticket" minimum="1">
					<!-- #default="{ index }" -->
					<div class="d-flex">
						<div class="mr-1 w-100">
							<FormulateInput
								label="Nombre del ticket"
								name="name"
								validation-name="Nombre del ticket"
								validation="required"
							/>
						</div>

						<div class="mr-1">
							<FormulateInput
								label="Precio"
								name="priceUnit"
								type="price"
								:currency="$store.getters.loggedAccount.currencySymbol"
								validation-name="Precio"
								validation="required"
							/>
							<!-- :help="
									`Precio final: ${$store.getters.loggedAccount.currencySymbol} ${addFeeToPrice(
										index
									)}`
								" -->
						</div>
						<div class="mr-1">
							<FormulateInput
								type="number"
								label="Cantidad"
								name="ticketsLimit"
								validation-name="Cantidad de tickets"
								:validation="`required|number|max:${form.ticketsLimit}`"
								:max="form.ticketsLimit"
								:validation-messages="{
									max: `La cantidad de tickets no puede superar al cupo de entradas del grupo (${form.ticketsLimit})`
								}"
							/>
						</div>
					</div>
				</FormulateInput>
			</div>
		</div>

		<hr />

		<div class="d-flex justify-content-between mt-4">
			<div>
				<div class="btn btn-light" @click="$emit('updated')">
					Cancelar
				</div>
				<div class="btn btn-link text-danger" v-if="action == 'update'" @click="deletePrompt()">
					Eliminar
				</div>
			</div>
			<div class="btn btn-primary disabled" v-if="saving">Guardando <span class="loader" /></div>
			<button type="submit" class="btn btn-primary" v-if="!saving">
				Guardar cambios
			</button>
		</div>
	</FormulateForm>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "eventTicketsGroupForm",
	props: {
		event: {
			type: Object,
			required: true
		},
		group: {
			type: Object,
			required: false
		}
	},

	data() {
		return {
			loading: true,
			saving: false,
			action: "create",

			eventTicketGroupId: null,
			form: {
				id: null,
				name: null,
				minPerOrder: 1,
				maxPerOrder: 10,
				holderRequired: false,
				ticketTypes: [
					{
						id: null,
						name: null,
						priceUnit: null,
						ticketsLimit: null
					}
				],
				ticketsLimit: 0,
				sellAt: null,
				validAt: null
			},
			limitDateAt: null,
			validAtEnd: true
		}
	},

	async mounted() {
		this.loading = true
		this.limitDateAt = this.$moment(this.event.endAt).format("YYYY-MM-DD HH:mm:01")
		this.action = "create"

		if (this.group) {
			this.action = "update"
			this.form = {
				id: this.group.id,
				name: this.group.name,
				minPerOrder: this.group.minPerOrder,
				maxPerOrder: this.group.maxPerOrder,
				ticketTypes: this.group.ticketTypes.map((ticketType) => {
					return {
						id: ticketType.id,
						name: ticketType.name,
						priceUnit: ticketType.priceUnit,
						ticketsLimit: ticketType.ticketsLimit
					}
				}),
				holderRequired: this.group.holderRequired,
				ticketsLimit: this.group.ticketsLimit,
				sellAt: this.$moment(this.group.sellAt).format("YYYY-MM-DD HH:mm:00"),
				validAt: this.$moment(this.group.validAt).format("YYYY-MM-DD HH:mm:00")
			}
			this.validAtEnd =
				this.$moment(this.group.sellAt).format("YYYY-MM-DD HH:mm:00") ==
				this.$moment(this.limitDateAt).format("YYYY-MM-DD HH:mm:00")
		} else {
			this.form.validAt = this.$moment(this.event.endAt).format("YYYY-MM-DD HH:mm:00")
			this.form.sellAt = this.$moment(this.event.endAt).format("YYYY-MM-DD HH:mm:00")
		}

		this.loading = false
	},

	methods: {
		validAtCheck() {
			if (this.validAtEnd) {
				this.$nextTick(() => {
					this.form.sellAt = this.$moment(this.limitDateAt).format("YYYY-MM-DD HH:mm:00")
				})
			}
		},
		// calculo cuanto va a pagar el cliente por la entrada.
		addFeeToPrice(index) {
			if (index >= 0 && this.form.ticketTypes[index]) {
				const price = parseFloat(this.form.ticketTypes[index].priceUnit)
				const fee = this.$store.getters.loggedAccount.fee
				return (price + price * (fee / 100)).toFixed(2)
			}
			return 0
		},

		// async loadEvent(id) {
		// 	return this.$apollo
		// 		.query({
		// 			query: gql`
		// 				query($id: ID!) {
		// 					event(id: $id) {
		// 						id
		// 						name
		// 						startAt
		// 						endAt
		// 					}
		// 				}
		// 			`,
		// 			variables: { id },
		// 			fetchPolicy: "no-cache"
		// 		})
		// 		.then(({ data }) => {
		// 			return data.event
		// 		})
		// },

		async save() {
			if (!this.saving) {
				this.saving = true
				let data = {
					event: this.event.id,
					name: this.form.name,
					minPerOrder: parseInt(this.form.minPerOrder),
					maxPerOrder: parseInt(this.form.maxPerOrder),
					ticketTypes: this.form.ticketTypes.map((ticketType) => ({
						id: ticketType.id || undefined,
						name: ticketType.name,
						priceUnit: parseFloat(ticketType.priceUnit),
						ticketsLimit: parseInt(ticketType.ticketsLimit)
					})),
					holderRequired: this.form.holderRequired,
					ticketsLimit: parseInt(this.form.ticketsLimit),
					validAt: this.validAtEnd ? this.limitDateAt : this.form.validAt,
					sellAt: this.form.sellAt
				}
				if (this.action == "create") await this.create(data)
				if (this.action == "update") await this.update(this.form.id, data)

				this.saving = false
			}
		},

		async create(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: EventTicketGroupInput!) {
							eventTicketGroupCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.$toast.success("Tickets creados correctamente")
					this.$emit("updated")
					return data.eventTicketGroupCreate
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.saving = false
				})
		},

		async update(id, data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: EventTicketGroupInput!) {
							eventTicketGroupUpdate(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id,
						data
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.$toast.success("Tickets editados correctamente")
					this.$emit("updated")
					return data.eventTicketGroupUpdate
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.saving = false
				})
		},

		deletePrompt() {
			this.$dialog
				.confirm(
					{
						title: "Eliminar entradas",
						body: `¿Está seguro que desea eliminar el tipo de entrada "<strong>${this.form.name}"</strong>?`
					},
					{
						okText: "Eliminar",
						customClass: "delete-prompt"
					}
				)
				.then(() => {
					this.delete()
				})
		},

		delete() {
			this.loading = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!) {
							eventTicketGroupDelete(id: $id) {
								id
							}
						}
					`,
					variables: {
						id: this.form.id
					}
				})
				.then(() => {
					this.$toast.success("Ticket eliminado correctamente")
					this.$emit("updated")
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.periods .period {
	display: flex;
}
</style>
